import moment from "moment";
import VATCountries from "../../middleware/Constants/VATCountriesList";

export { getCountryName, getStateName, isCanadianOrUsaCountry, isUsaCountry } from "../../middleware/Utils/CountriesUtils";
export { capitalizeFirstLetter } from "./StringUtils";
export { debounce } from "./DebounceUtils";

export const hasPaymentMethod = (payments) => {
    if (!payments || !payments.data) {
        return false;
    }

    return payments.data.length > 0;
}

export const hasInvoicesAccount = (invoices) => {
    if (invoices && invoices.account) {
        return true;
    }

    return false;
}

export const hasInvoicesReceipt = (invoices) => {
    if (!invoices) {
        return false;
    }

    return invoices.total > 0;
}

export const isExpired = (payment) => {
    if (payment) {
        if (payment.Type === "CreditCard") {
            let expiredDate = expired_date(payment.CreditCardExpirationMonth, payment.CreditCardExpirationYear);
            let now = new moment(new Date());
            let endOfNextMonth = new moment(new Date()).add(1, "month").endOf("month");

            if (expiredDate.isBefore(now)) {
                return true;
            } else if (expiredDate.isBefore(endOfNextMonth)) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    } else {
        return false;
    }
}

let expired_date = (month, year) => {
    return moment(month.toString() + "-01-" + year.toString(), "MM-DD-YYYY").endOf("month");
}

export let getStateOfCC = (payment, intl = null) => {
    if (payment) {
        if (payment.Type === "CreditCard") {
            let expiredDate = expired_date(payment.CreditCardExpirationMonth, payment.CreditCardExpirationYear);
            let now = new moment(new Date());
            let endOfNextMonth = new moment(new Date()).add(1, "month").endOf("month");

            if (expiredDate.isBefore(now)) {
                return intl.messages.billingCardExpired;//"Card Expired";
            } else if (expiredDate.isBefore(endOfNextMonth)) {
                return intl.messages.billingCardSoon;//"Expires soon";
            } else {
                return "";
            }
        } else {
            return "";
        }
    } else {
        return "";
    }
};

export let getStatusOfCard = (payment, intl = null) => {
    if (payment) {
        if (payment.Type === "CreditCard") {
            let expiredDate = expired_date(payment.CreditCardExpirationMonth, payment.CreditCardExpirationYear);

            let now = new moment(new Date());
            let endOfNextMonth = new moment(new Date()).add(1, "month").endOf("month");

            if (expiredDate.isBefore(now)) {
                return { label: intl.messages.billingExpired, style: "expired" };//"Expired";
            } else if (expiredDate.isBefore(endOfNextMonth)) {
                return { label: intl.messages.billingCardSoon, style: "soon" }//"Expires soon";
            } else {
                if (payment.isDefaultPaymentMethod)
                    return { label: intl.messages.billingCardActive, style: "active" };//"Active";
                return { label: intl.messages.billingNoUsed, style: "inused" };//"No more used";
            }
        } else {
            if (payment.isDefaultPaymentMethod)
                return { label: intl.messages.billingCardActive, style: "active" };
            return { label: intl.messages.billingNoUsed, style: "inused" };//"No more used";
        }
    }
};

export let isVatError = (taxInfo) => {
    let isError = false;
    if (taxInfo == null || taxInfo.VATId == null || taxInfo.VATId === "")
        isError = true;
    else if (taxInfo.checkVat?.status === "invalid" || taxInfo.checkVat?.status === "failed")
        isError = true;
    return isError;
}

export let isVatSuccess = (taxInfo) => {
    let isSuccess = false;
    if (taxInfo?.checkVat?.status === "valid")
        isSuccess = true;
    return isSuccess;
}

export let getVatStatusMessage = (taxInfo, intl = null) => {
    if (taxInfo && taxInfo.checkVat) {
        switch (taxInfo.checkVat.status) {
            case "valid":
                return intl.messages.invoicesVATStatusValid;
            case "invalid":
                return intl.messages.invoicesVATStatusInValid;
            case "failed":
                return intl.messages.invoicesVATStatusFailed;
            case "pending":
                return intl.messages.invoicesVATStatusPending;
            default:
                return intl.messages.invoicesVATStatusWrong;
        }
    } else if (taxInfo == null || taxInfo.VATId == null || taxInfo.VATId === "") {
        return "VAT field is empty";
    } else {
        return "";
    }
};

export let getCurrencySymbol = currency => {
    switch (currency) {
        case "EUR":
            return "€";
        default:
            return "$";
    }
};

export let isVATDisplay = country => {
    if (country) {
        let vatFound = VATCountries.some(ctry => { return country === ctry["alpha-3"] });
        return vatFound;
    } else {
        return false;
    }
};

export const getDefaultPaymentMethod = payments => {
    let defaultPayment = null;

    if (!payments || payments.length === 0) {
        return defaultPayment;
    }

    defaultPayment = payments.find(payment => payment.isDefaultPaymentMethod);
    return defaultPayment;
};

let getHistoricPaymentMethod = payments => {
    let historic = [];

    if (payments && payments.length > 0)
        historic = payments.filter(payment => payment.isDefaultPaymentMethod === false);//exclude defaultPaymentMethod

    return historic;
};

export const getOrderedPaymentMethod = payments => {
    let val = getHistoricPaymentMethod(payments);

    function compare(a, b) {
        if (moment(a.CreatedDate).isBefore(moment(b.CreatedDate))) return 1;
        if (moment(a.CreatedDate).isAfter(moment(b.CreatedDate))) return -1;
        return 0;
    }
    return val.sort(compare);
};

export const isInvoiceAccountFullyFilled = (account) => {
    let isValid = false;

    if (account?.data?.basicInfo?.name?.length > 0
        && (!isVATDisplay(account?.data?.billToContact?.country) || account?.data?.taxInfo?.VATId?.length > 0)
        && account?.data?.billToContact?.zipCode?.length > 0
        && account?.data?.billToContact?.city?.length > 0
        && (account?.data?.billToContact?.address1?.length > 0 || account?.data?.billToContact?.address2?.length > 0)
    )
        isValid = true;
    return isValid;
}